import React, { useEffect, useState, useRef } from "react";
import growthicon from "../../../assets/img/GG210.png";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { BiArrowBack } from "react-icons/bi";
import { Input } from "reactstrap";
import * as yup from "yup";
import { Formik } from "formik";
import axios from "axios";
import { API_AUTH } from "../../../utils/config";
import Navigation from "../../../common/Navigation";
import { useLocation, useHistory } from "react-router-dom";
//  sign up password component
const Signuppassword = (props) => {
  const [hidden, setHidden] = useState(true);
  let location = useLocation();
  let history = useHistory();
  // validation schema
  const passValidationSchema = yup.object().shape({
    password: yup
      .string()
      .matches(
        "^(?=.*\\d)(?=.*[!@$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$",
        "Password must be alphanumeric , min 1 cap and 8 characters"
      )
      .min(8, ({ min }) => `Password must be at least ${min} characters`)
      .required("Password is required")
      .max(20, "Password must be below 9 characters"),
  });
  const textInput = useRef(null);

  useEffect(() => {
    checkingCurrentUser();
    textInput.current.focus();
  });
  // checking current candidate function
  const checkingCurrentUser = () => {
    axios
      .get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true })
      .then((response) => {
        if (response.data) {
          history.push({
            pathname: "/dashboard",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleShow = () => {
    setHidden(!hidden);
  };
   // onSubmit function for navigating to create candidate component
  const handleSubmit = async (password) => {
    let body = {
      email: location.state,
      password,
      ipAddress: "150.82.224.211",
      browser: "",
      OS: "",
      isTablet: false,
      isPhone: false,
      isBot: false,
      location: "",
      isSuspicious: false,
    };

    await axios
      .post(`${API_AUTH}/v1/api/auth/signup`, body, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.ok) {
          // history.push({
          //   pathname:"/validateuser"
          // })
        window.location = "/validateuser"
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Navigation show="true" />
      <Formik
        validationSchema={passValidationSchema}
        initialValues={{ password: "" }}
        onSubmit={(values) => handleSubmit(values.password)}
      >
        {({
          handleChange,
          handleSubmit,
          values,
          errors,
          touched,
          isValid,
          validationSchema,
        }) => (
          <>
            <div className="sign-container">
              <div className="child-signcontainer">
                <Link
                  style={{
                    color: "#005500",
                    marginLeft: "30px",
                    marginTop: "30px",
                  }}
                  to="/signup"
                >
                  {" "}
                  <h4>
                    {" "}
                    <BiArrowBack />{" "}
                  </h4>
                </Link>
                <div className="child-firstcontainer">
                  <img
                    style={{ marginRight: "20px" }}
                    src={growthicon}
                    height="60"
                    width="170"
                    alt="PION global"
                    id="logo"
                  ></img>
                </div>

                <div className="child-secondcontainer">
                  <span style={{ fontWeight: 500, fontSize: "20px" }}>
                    Create a Password
                  </span>

                  <div className="sign-form">
                    <input
                      type={hidden ? "password" : "text"}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      name="password"
                      ref={textInput}
                      placeholder=" Create Password"
                      onChange={handleChange("password")}
                      value={values.password}
                      autoComplete="off"
                      required
                    ></input>
                    {errors.password && touched.password && (
                      <span style={{ fontSize: "12px", color: "red" }}>
                        {errors.password}
                      </span>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",

                      marginTop: "-10px",
                    }}
                  >
                    <Input type="checkbox" onClick={toggleShow} />
                    <span style={{ fontSize: "14px", marginLeft: "8px" }}>
                      Show Password
                    </span>
                  </div>
                </div>
                <div
                  className="log-button"
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={!isValid}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      background: "#005500",
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};

export default Signuppassword;
